export const COOKIE_CONSENT_STORAGE_KEY = "nb_cookie_consent";

export const getStoredCookieConsent = () => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const value = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (value === "accepted" || value === "rejected") {
      return value;
    }
    return null;
  } catch {
    return null;
  }
};
